export default __webpack_public_path__ + "assets/dec4476cea6d6485a36d5f37d9bf54c6.jpg";